import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const ContentContext = createContext(null);

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await axios.get(`${API}/api/content`);
      setContent(response.data.content);
      setError(null);
    } catch (err) {
      console.error('Error fetching content:', err);
      setError('Failed to load content');
    }
    setLoading(false);
  };

  const refreshContent = async () => {
    setLoading(true);
    await fetchContent();
  };

  // Helper function to get content by section and key
  const getContent = (section, key, fallback = '') => {
    if (!content || !content[section]) return fallback;
    return content[section][key] || fallback;
  };

  // Helper function to get an entire section
  const getSection = (section, fallback = {}) => {
    if (!content) return fallback;
    return content[section] || fallback;
  };

  // Helper to parse pipe-separated strings into arrays (for bullets)
  const getBullets = (section, key, fallback = []) => {
    const value = getContent(section, key, '');
    if (!value) return fallback;
    return value.split('|').filter(Boolean);
  };

  return (
    <ContentContext.Provider value={{ 
      content, 
      loading, 
      error, 
      refreshContent,
      getContent,
      getSection,
      getBullets
    }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => {
  const context = useContext(ContentContext);
  if (!context) {
    throw new Error('useContent must be used within a ContentProvider');
  }
  return context;
};

export default ContentContext;
